if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (this.variantIdInput) this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton ? this.submitButton.querySelector('span') : null;

        if (document.querySelector('cart-drawer') && this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const submitter = evt.submitter || document.activeElement;
        const isBuyNow = submitter && (
          submitter.getAttribute('aria-label') === 'Buy Now' ||
          submitter.dataset.buyNow === 'true' ||
          submitter.classList.contains('pdp-buy-now-btn') ||
          (submitter.closest && submitter.closest('.pdp-buy-now-btn'))
        );

        const currentSubmitBtn = (submitter && submitter.matches && submitter.matches('button, [type="submit"]')) ? submitter : (this.submitButton || this.querySelector('[type="submit"]'));
        if (currentSubmitBtn && currentSubmitBtn.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        if (currentSubmitBtn) {
          currentSubmitBtn.setAttribute('aria-disabled', 'true');
          currentSubmitBtn.classList.add('loading');
        }
        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/javascript'
          }
        };
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart && !isBuyNow) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        const cartAddUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';

        fetch(cartAddUrl, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
              }
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton ? this.submitButton.querySelector('.sold-out-message') : null;
              if (soldOutMessage) {
                if (this.submitButton) this.submitButton.setAttribute('aria-disabled', 'true');
                if (this.submitButtonText) this.submitButtonText.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
              }
              this.error = true;
              return;
            }

            if (isBuyNow) {
              window.location.href = '/checkout';
              return;
            }

            // Update cart bubbles everywhere
            const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
            fetch(rootUrl + 'cart.js')
              .then((r) => r.json())
              .then((cart) => {
                document.querySelectorAll('.cart-count-bubble span[data-cart-count], .cart-count-bubble span').forEach(el => { el.textContent = cart.item_count; });
              });

            if (!this.cart) {
              window.location.href = window.routes ? window.routes.cart_url : '/cart';
              return;
            }

            if (!this.error && typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            }
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
            if (isBuyNow) {
              window.location.href = '/checkout';
            } else {
              window.location.href = window.routes ? window.routes.cart_url : '/cart';
            }
          })
          .finally(() => {
            if (currentSubmitBtn) {
              currentSubmitBtn.classList.remove('loading');
              if (!this.error) currentSubmitBtn.removeAttribute('aria-disabled');
            }
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (spinner) spinner.classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text && this.submitButtonText) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          if (this.submitButtonText && window.variantStrings) this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
